var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar-item avatar",class:{ interactive: _vm.interactive}},[(this.user)?_c('span',[_vm._v(_vm._s(this.user.initials))]):_c('span',[_vm._v("🐶")])])}
var staticRenderFns = []

export { render, staticRenderFns }